import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

// Thin gradient bar at the top of the page showing how far you've scrolled.
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[60] bg-gradient-to-r from-designColor via-[#ff4d7e] to-[#ff8a5c]"
    />
  );
};

export default ScrollProgress;
